function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 38,
  r: 36,
  fill: "#EBF3FE"
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 37.792,
  cy: 26.41,
  rx: 1.849,
  ry: 1.861,
  fill: "#338AF3"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 35.942,
  y: 32.66,
  width: 3.699,
  height: 19.357,
  rx: 1.849,
  fill: "#338AF3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M55.657 6.816A35.433 35.433 0 0037.77 2C18.015 2 2 18.118 2 38s16.015 36 35.771 36 35.771-16.118 35.771-36c0-4.138-.693-8.112-1.97-11.813",
  stroke: "#338AF3",
  strokeWidth: 3.5,
  strokeLinecap: "round"
});

function SvgIcoInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "/img/ico-info.svg";
export { SvgIcoInfo as ReactComponent };